import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { CurrencyProvider } from "@/lib/currency";
import { api } from "@/lib/api";
import HomePage from "@/pages/HomePage";
import RoomsPage from "@/pages/RoomsPage";
import RoomDetailPage from "@/pages/RoomDetailPage";
import BookingPage from "@/pages/BookingPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import LoginPage from "@/pages/LoginPage";
import MyBookingsPage from "@/pages/MyBookingsPage";
import PolicyPage from "@/pages/PolicyPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import ReviewsPage from "@/pages/ReviewsPage";
import InfoPage from "@/pages/InfoPage";
import ManageBookingPage from "@/pages/ManageBookingPage";
import ManageBookingDetailPage from "@/pages/ManageBookingDetailPage";
import StaffDashboard from "@/pages/staff/StaffDashboard";
import StaffRoomsPage from "@/pages/staff/StaffRoomsPage";
import StaffBookingsPage from "@/pages/staff/StaffBookingsPage";
import StaffPricingPage from "@/pages/staff/StaffPricingPage";
import StaffChannelsPage from "@/pages/staff/StaffChannelsPage";
import StaffVaultPage from "@/pages/staff/StaffVaultPage";
import StaffPoliciesPage from "@/pages/staff/StaffPoliciesPage";
import StaffSettingsPage from "@/pages/staff/StaffSettingsPage";
import StaffReviewsPage from "@/pages/staff/StaffReviewsPage";
import StaffMessagesPage from "@/pages/staff/StaffMessagesPage";
import StaffMediaPage from "@/pages/staff/StaffMediaPage";
import StaffUsersPage from "@/pages/staff/StaffUsersPage";
import StaffContentPage from "@/pages/staff/StaffContentPage";
import StaffSecurityPage from "@/pages/staff/StaffSecurityPage";
import StaffPaymentsPage from "@/pages/staff/StaffPaymentsPage";
import StaffPartnersPage from "@/pages/staff/StaffPartnersPage";

function GA4Loader() {
  useEffect(() => {
    api.get("/settings").then((r) => {
      const id = r.data?.ga4_id?.value;
      if (!id || !id.startsWith("G-") || document.getElementById("ga4-script")) return;
      const s = document.createElement("script");
      s.id = "ga4-script";
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      s.async = true;
      document.head.appendChild(s);
      const s2 = document.createElement("script");
      s2.text = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${id}');`;
      document.head.appendChild(s2);
    }).catch(() => {});
  }, []);
  return null;
}

function App() {
  return (
    <I18nProvider>
      <CurrencyProvider>
      <AuthProvider>
        <BrowserRouter>
          <GA4Loader />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/rooms" element={<RoomsPage />} />
            <Route path="/rooms/:id" element={<RoomDetailPage />} />
            <Route path="/book/:roomId" element={<BookingPage />} />
            <Route path="/booking/success" element={<BookingSuccessPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/my-bookings" element={<MyBookingsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/info/:section" element={<InfoPage />} />
            <Route path="/manage" element={<ManageBookingPage />} />
            <Route path="/manage/:bookingId" element={<ManageBookingDetailPage />} />
            <Route path="/policies" element={<Navigate to="/policies/cancellation" replace />} />
            <Route path="/policies/:slug" element={<PolicyPage />} />

            <Route path="/staff/login" element={<LoginPage staff />} />
            <Route path="/staff" element={<StaffDashboard />} />
            <Route path="/staff/rooms" element={<StaffRoomsPage />} />
            <Route path="/staff/pricing" element={<StaffPricingPage />} />
            <Route path="/staff/channels" element={<StaffChannelsPage />} />
            <Route path="/staff/vault" element={<StaffVaultPage />} />
            <Route path="/staff/bookings" element={<StaffBookingsPage />} />
            <Route path="/staff/reviews" element={<StaffReviewsPage />} />
            <Route path="/staff/messages" element={<StaffMessagesPage />} />
            <Route path="/staff/media" element={<StaffMediaPage />} />
            <Route path="/staff/users" element={<StaffUsersPage />} />
            <Route path="/staff/policies" element={<StaffPoliciesPage />} />
            <Route path="/staff/content" element={<StaffContentPage />} />
            <Route path="/staff/security" element={<StaffSecurityPage />} />
            <Route path="/staff/payments" element={<StaffPaymentsPage />} />
            <Route path="/staff/partners" element={<StaffPartnersPage />} />
            <Route path="/staff/settings" element={<StaffSettingsPage />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
      </CurrencyProvider>
    </I18nProvider>
  );
}

export default App;
